import React, { useContext ,useRef , useState,useEffect } from 'react'
import noteContext from '../../contex/notes/noteContext';
import Todayitem from './Todayitem';
import Login from '../Authentication/Login';


const Todo = () => {

const authtoken = localStorage.getItem("token")
let user= false
 if(authtoken){
  user = true
 }

  const context = useContext(noteContext)
  const {fetchTodo,AddTodo,maindata} = context;
//  need to set the date
const [Todo, setTodo] = useState({work:"Enter ",date:"2024-05-15"})
const onChange = (e)=>{
  setTodo({...Todo, [e.target.name]: e.target.value})
}
const ref = useRef(null)
// iteration to stop previous date todos
const handleClick = (e)=>{
  e.preventDefault();
  AddTodo(Todo)
  setTodo({work:" ",date:Todo.date})
  ref.current.click()
}

useEffect(() => {
  fetchTodo();
  }, [])
  if(user){
  return (

    <div style={{padding:"60px 16px 16px" , height:window.screen.height , background: "rgb(0,0,0,0.46) url(https://img.freepik.com/free-photo/abstract-blue-sky-watercolour-ink-backdrop_23-2148300857.jpg?w=900&t=st=1715864709~exp=1715865309~hmac=534f23bb76f4cf23fe68e4020fc5255d6cd3342e09d19a67dc7944bb330b8b5b)" , backgroundRepeat : "no-repeat" , backgroundSize : "cover", backgroundBlendMode : "darken"}}>
      <div style={{margin:"6px 0px"}}>
       <h2 className={`text-center ${(maindata.todaytodo.length === 0 )? "d-none":" "} my-4`}>Today</h2>
       {maindata.todaytodo.map((l)=>{
        return <Todayitem key={l._id} obj = {l}/>
       })}
      </div>
      
      <div style={{margin:"6px 0px"}}>
      <h2 className={`text-center ${(maindata.tommorowtodo.length === 0 )? "d-none":" "} my-4`}>Tommorow</h2>
       {maindata.tommorowtodo.map((e)=>{
        return <Todayitem key={e._id} obj = {e}/>
       })}
      </div>

      <div style={{margin:"6px 0px"}}>
      <h2 className={`text-center ${(maindata.extratodo.length === 0 )? "d-none":" "} my-4`}>Upcoming Todos</h2>
       {maindata.extratodo.map((k)=>{
        return <Todayitem key={k._id} obj = {k}/>
       })}
      </div>

      {/* modal starts here for creating todo */}
        <button type="button" className="btn add btn-dark" data-bs-toggle="modal" data-bs-target="#exampleModal">
        New To-Do
        </button>

        <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{backdropFilter:" blur(2px)"}}>
          <div className="modal-dialog">
            <div className="modal-content" style={{fontFamily: "monospace",  background: "#b1b1b1"}}>
              <div className="modal-header" style={{borderBottom:" .5px solid #9b9999"}}>
                <h1 className="modal-title fs-5" id="exampleModalLabel">Add new To-Do</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">To-do</label>
                    <input type="text" name='work' value = {Todo.work} className="form-control"onChange={onChange} id="exampleInputEmail1" aria-describedby="emailHelp"/>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputDate" className="form-label">Date</label>
                    <input type="date" name='date' value = {Todo.date} className="form-control"onChange={onChange} id="exampleInputDate"/>
                  </div>
                  <button type="submit" onClick = {handleClick} className="btn btn-info">Create</button>   
                </form>
              </div>
              <div className="modal-footer" style={{borderTop:" .5px solid #9b9999"}}>
                <button type="button" ref = {ref} className="btn d-none btn-primary" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
       
    </div>
  )
      }
      else{
        return(
          <>
          <Login/>
          </>
        )
      }
}

export default Todo
